import { render, staticRenderFns } from "./assignmentTaskList.vue?vue&type=template&id=71cda8f0&scoped=true&"
import script from "./assignmentTaskList.vue?vue&type=script&lang=js&"
export * from "./assignmentTaskList.vue?vue&type=script&lang=js&"
import style0 from "./assignmentTaskList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./assignmentTaskList.vue?vue&type=style&index=1&id=71cda8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cda8f0",
  null
  
)

export default component.exports